export default () => [
    {
      id: 'default',
      name: ' '
    },
  
    {
      id: '1',
      name: 'Issue'
    },
  
    {
      id: '2',
      name: 'Text Message'
    },
  
    {
      id: '3',
      name: 'Other'
    },
  
    
    
  ];
  